import { CITIES } from './city.config';

export const environment = {
  production: false,
  apiUrl: 'https://api.lapaz.dev.syncc.me',
  tileServerUrl: 'https://tiles.syncc.me/styles/basic-preview/{z}/{x}/{y}.png',
  city: CITIES['lapaz'],
};
